import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "container p-0 mt-2" }
const _hoisted_2 = ["aria-labelledby", "aria-describedby"]
const _hoisted_3 = { class: "form-check form-check-inline" }
const _hoisted_4 = ["id", "name", "onUpdate:modelValue", "required", "disabled"]
const _hoisted_5 = ["for"]
const _hoisted_6 = {
  key: 0,
  class: "input-group-append"
}
const _hoisted_7 = ["id", "hidden"]
const _hoisted_8 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "row",
      role: "group",
      "aria-labelledby": _ctx.ids.label,
      "aria-describedby": _ctx.describedBy
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["form-group", { 'was-validated': $props.wasValidated }])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.selectOptions, (option, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "col-auto"
          }, [
            _createElementVNode("div", _hoisted_3, [
              _withDirectives(_createElementVNode("input", {
                onChange: _cache[0] || (_cache[0] = ($event: any) => ($options.checkboxChanged())),
                class: "form-check-input",
                type: "checkbox",
                id: _ctx.ids.option(index),
                name: $props.element.name,
                "onUpdate:modelValue": ($event: any) => (($data.elData[option.name]) = $event),
                required: $options.isRequired,
                disabled: $props.hidden
              }, null, 40, _hoisted_4), [
                [_vModelCheckbox, $data.elData[option.name]]
              ]),
              _createElementVNode("label", {
                class: "form-check-label",
                for: _ctx.ids.option(index)
              }, _toDisplayString($options.getTextFor(option.text,$props.lang)), 9, _hoisted_5)
            ])
          ]))
        }), 128)),
        ($data.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[1] || (_cache[1] = [
              _createElementVNode("span", { class: "input-group-text" }, [
                _createElementVNode("div", {
                  class: "spinner-border spinner-border-sm",
                  role: "status"
                }, [
                  _createElementVNode("span", { class: "visually-hidden" }, "Laden...")
                ])
              ], -1)
            ]))]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "invalid-feedback",
          id: _ctx.ids.error,
          hidden: !_ctx.ongeldig
        }, _toDisplayString($options.getTextFor($props.element.invalid, $props.lang) || 'Maak een keuze.'), 9, _hoisted_7),
        (_ctx.heeftUitleg)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              id: _ctx.ids.help,
              class: "form-text"
            }, _toDisplayString($options.getTextFor($props.element.explanation,$props.lang)), 9, _hoisted_8))
          : _createCommentVNode("", true)
      ], 2)
    ], 8, _hoisted_2)
  ], 512)), [
    [_vShow, !$props.hidden]
  ])
}